import React, { useRef, useState, useEffect } from 'react'
import SbEditable from 'storyblok-react'
import classnames from 'classnames'

import TextRenderer from './../TextRenderer'

import styles from './styles.module.scss'
import gsap from 'gsap'

const Downloads = (props) => {

    const downloadItemRefs = useRef([])
    const [activeDownloadsIndex, setActiveDownloadsIndex] = useState(-1)

    const toggleDownloadItem = index => {
        if (index == activeDownloadsIndex) {
            setActiveDownloadsIndex(-1)
            gsap.to(downloadItemRefs.current[index], { height: 0.0 })
            
        } else {
            setActiveDownloadsIndex(index)
            gsap.to(downloadItemRefs.current[index], { height: 'auto' })
        }
    }
    
    useEffect(() => {
        downloadItemRefs.current.forEach(item => {
            gsap.set(item, { height: 0 })
        })
    }, [])

    return (
        <SbEditable content={props.blok}>
			<section className={styles['downloads']} id='downloads'>
                <div className={`container`}>
                    <div className='row'>
                        <div className='col'>
                            <TextRenderer text={props.blok.description} className={styles['downloads__heading']} />
                        </div>
                        <div className='col'>
                            <ul className={styles['downloads__list']}>
                                {props.blok.accordion.map((blok, i) => {

                                    const buttonClasses = classnames({
                                        'button': true,
                                        [styles['downloads-item__button']]: true,
                                        [styles['downloads-item__button--active']]: i == activeDownloadsIndex,
                                    })

                                    return (
                                        <SbEditable key={i} content={blok}>
                                            <li className={styles['downloads-item']}>
                                                <div className={styles['downloads-item__header']}>
                                                    <button className={buttonClasses} onClick={() => toggleDownloadItem(i)}><span className={styles['downloads-item__button-inner']}>+</span></button>
                                                    <p className={`heading-4 ${styles['downloads-item__title']}`}>{blok.title}</p>
                                                </div>
                                                <div ref={el => downloadItemRefs.current[i] = el} className={styles['downloads-item__content']}>
                                                    {blok.downloads.map(download => {
                                                        return (
                                                            <SbEditable key={download._uid} content={download}>
                                                                <a href={download.asset.filename || ''} target='_blank' className={`body ${styles['downloads-item__link']}`}>{`> ${download.label}`}</a>
                                                            </SbEditable>
                                                        )
                                                    })}
                                                </div>
                                            </li>
                                        </SbEditable>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
		</SbEditable>
    )
}

export default Downloads
